import YNotificationsPanel from './NotificationsPanel';

export { YNotificationsPanel };
export default YNotificationsPanel;
